/**
 * Normalize track list data from various API response formats
 * Handles: arrays, objects with numeric keys, nested responses
 *
 * @param {*} data - API response data
 * @returns {Array} - Normalized array of track objects
 */
export function normalizeTrackList (data) {
  // Already an array - return as is
  if (Array.isArray(data)) {
    return data
  }

  // Nested under 'tracks' key
  if (data && data.tracks && Array.isArray(data.tracks)) {
    return data.tracks
  }

  // Object with numeric keys: {0: track, 1: track, 2: track}
  // This is common with PHP APIs
  if (data && typeof data === 'object') {
    const values = Object.values(data)

    // Check if it looks like track objects
    if (values.length > 0 && values[0] && typeof values[0] === 'object') {
      // Verify it has track-like properties
      const firstItem = values[0]
      if (firstItem.songid || firstItem.trackid || firstItem.tracktitle) {
        return values
      }
    }
  }

  // Unknown format - return empty array
  console.warn('normalizeTrackList: Unknown data format', data)
  return []
}

/**
 * Normalize a single track object
 * Ensures consistent field names and types
 *
 * @param {Object} track - Track data
 * @returns {Object} - Normalized track object
 */
export function normalizeTrack (track) {
  if (!track) return null

  return {
    ...track,
    // Ensure rating is a number
    rating: track.rating ? parseFloat(track.rating) : 0,
    // Ensure IDs are strings
    songid: track.songid ? String(track.songid) : '',
    trackid: track.trackid ? String(track.trackid) : track.songid ? String(track.songid) : '',
    // Ensure duration is present
    duration: track.duration || null
  }
}

export default {
  normalizeTrackList,
  normalizeTrack
}
